import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=65d66654&scoped=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=ts"
export * from "./LanguagePicker.vue?vue&type=script&lang=ts"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=65d66654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d66654",
  null
  
)

export default component.exports